import { Component, EventEmitter, Input, input, Output } from '@angular/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'btn-icon',
  standalone: true,
  imports: [],
  templateUrl: './btn-icon.component.html',
  styleUrl: './btn-icon.component.css',
})
export class BtnIconComponent {
  @Input() isDisabled: Observable<boolean> = of(false);
  @Input() isLoading: Observable<boolean> = of(false);

  icon = input.required<string>();

  bgColor = input<string>('bg-transparent');
  bgDisabledColor = input<string>('bg-primary-100');
  textColor = input<string>('text-primary-500');
  textHoverColor = input<string>('text-secondary-300');
  textActiveColor = input<string>('text-secondary-500');
  addClasses = input<string>('');
  padding = input<string>('px-2');

  @Output() onClick = new EventEmitter<void>();

  handleClick(): void {
    this.onClick.emit();
  }
}
